module.exports = __webpack_public_path__ + "img/business-board-landing.9f3e1c51.jpg";